import { CurrentRoundResults } from '../currentRoundResults';

function GameLeftSide() {
  return <CurrentRoundResults />;
}

export default GameLeftSide;
